import * as crypto from "crypto";

export class CommonUtil {
  public static generateRandom(max: number = 10) {
    return Math.floor(Math.random() * max);
  }
  public static generateUUID() {
    return crypto.randomUUID();
  }
  public static convertHtmlToPlainTextRegex(html: string): string {
    //console.log(html);
    //return html.replace(/<[^>]*>+|&gt;|&.bsp;/g, '');
    //return htmlToText.convert(html, {});
    var tempDivElement = document.createElement("div");

    // Set the HTML content with the given value
    tempDivElement.innerHTML = html;

    // Retrieve the text property of the element
    let result = tempDivElement.textContent || tempDivElement.innerText || "";
    return result.substring(0, 150); // Limit to 100 characters
  }
}
